module.exports = __webpack_public_path__ + "img/question-octagon.1df03499.svg";